module.exports = __webpack_public_path__ + "img/guide.7b450236.png";